import { useTranslation } from "react-i18next";
import NotificationReasonPicker from "./NotificationReasonPicker";
import NotificationRemovalTimePicker from "./NotificationRemovalTimePicker";

const NotificationSortingCampaignForm = ({
  materialToDisplay,
  objectRemoved,
  setObjectRemoved,
  removalTime,
  setRemovalTime,
  reason,
  setReason,
  reasonList,
  specificReason,
  setSpecificReason,
  isReady,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const objectCount = Math.max(
    1,
    parseInt(materialToDisplay[0]?.count, 10) || 1,
  );
  const removalQuestion =
    objectCount > 1
      ? t("mobile_notifications_objects_removed_question_other", {
          count: objectCount,
        })
      : t("mobile_notifications_objects_removed_question_one");

  const selectRemoved = () => {
    setObjectRemoved(true);
    setReason(null);
    setSpecificReason("");
  };

  const selectNotRemoved = () => {
    setObjectRemoved(false);
    if (!reason) {
      setReason(reasonList[0]);
    }
  };

  return (
    <div className="notification-campaign-form">
      <p className="notification-campaign-question">{removalQuestion}</p>

      <div className="notification-campaign-removal-toggle" role="group">
        <button
          type="button"
          className={
            objectRemoved
              ? "notification-campaign-toggle-button notification-campaign-toggle-button-active"
              : "notification-campaign-toggle-button"
          }
          onClick={selectRemoved}
        >
          {t("Yes")}
        </button>
        <button
          type="button"
          className={
            !objectRemoved
              ? "notification-campaign-toggle-button notification-campaign-toggle-button-active"
              : "notification-campaign-toggle-button"
          }
          onClick={selectNotRemoved}
        >
          {t("No")}
        </button>
      </div>

      {objectRemoved && (
        <NotificationRemovalTimePicker
          value={removalTime}
          onChange={setRemovalTime}
          embedded
        />
      )}

      {!objectRemoved && (
        <NotificationReasonPicker
          reason={reason}
          onSelectReason={setReason}
          reasonList={reasonList}
          specificReason={specificReason}
          onSpecificReasonChange={setSpecificReason}
        />
      )}

      <button
        type="button"
        className="installation-save-sheet-button notification-campaign-submit"
        disabled={!isReady}
        onClick={onSubmit}
      >
        {t("Validate")}
      </button>
    </div>
  );
};

export default NotificationSortingCampaignForm;
